import { takeLatest, put, call } from 'redux-saga/effects';

import { fetchOfferTypeDetails } from '../actions/fetchOfferTypeDetails';
import { fetchOfferTypes, fetchOfferTypesSuccess, fetchOfferTypesFailure } from '../slices/offerTypesListSlice';

function* getUserProjectDetails(action:any):Generator<any, void, string> {
  try {
    const { tenantId, objectId } = action.payload;
      // Call the saveFormData API function with the with tenantId and objectId
    const projectDetails:any = yield call(fetchOfferTypeDetails, tenantId, objectId); 
     // Dispatch the fetchOfferTypesSuccess action with the response data
    yield put(fetchOfferTypesSuccess(projectDetails));
  } catch (error:any) {
     // If there is an error, dispatch the fetchOfferTypesFailure action with the error message
    yield put(fetchOfferTypesFailure(error.message));
  }
}

// Watcher saga
function* offerTypesSaga() {
   // Listen for the fetchOfferTypes action and call the getUserProjectDetails saga when dispatched
  yield takeLatest(fetchOfferTypes.type, getUserProjectDetails);
}

export default offerTypesSaga;